import { render, staticRenderFns } from "./DesignPopupPreviewPopup.vue?vue&type=template&id=8876caae&scoped=true&"
import script from "./DesignPopupPreviewPopup.vue?vue&type=script&lang=ts&"
export * from "./DesignPopupPreviewPopup.vue?vue&type=script&lang=ts&"
import style0 from "./DesignPopupPreviewPopup.vue?vue&type=style&index=0&id=8876caae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8876caae",
  null
  
)

export default component.exports